import { actionCreators as developmentSiteActionCreators } from '@app/routes/Development/Clients/Sites/View/modules/developmentSiteView'
import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import EarnestMoneyListPage from '../components/EarnestMoneyListPage'
import {
  actionCreators,
  IEarnestMoneyListState,
  selectError,
  selectFilterText,
  selectIsLoading,
  selectItems,
  selectTotalItems,
} from '../modules/earnestMoneyList'

export default connect(
  createStructuredSelector<ApplicationState, IEarnestMoneyListState>({
    error: selectError(),
    filterText: selectFilterText(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    totalItems: selectTotalItems(),
  }),
  Object.assign({}, actionCreators, developmentSiteActionCreators),
)(EarnestMoneyListPage)
